import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-image-modal',
  templateUrl: './view-image-modal.component.html',
  styleUrl: './view-image-modal.component.scss'
})
export class ViewImageModalComponent {

  @Input() imageBase64: string = '';

}
